import { updateObject } from "../Utility";
import {
  PENDING_RA_START,
  PENDING_RA_FAIL,
  PENDING_RA_SUCCESS,
} from "../actions/RecruitmentAgenciesActions";

const initialState = {
  next: null,
  previous: null,
  count: 0,
  page_size: 0,
  items: [],
  loading: false,
  fetched: false,
  error: null,
};

// pending RAS
export const getPendingRaSuccess = (state, action) => {
  return updateObject(state, {
    items: action.ras.results,
    next: action.ras.next,
    previous: action.ras.previous,
    count: action.ras.count,
    page_size: action.ras.page_size,
    loading: false,
    fetched: true,
    error: null,
  });
};

export const getPendingRaFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

export const getPendingRaStart = (state, action) => {
  return updateObject(state, {
    loading: true,
    error: null,
  });
};

const PendingRaReducer = (state = initialState, action) => {
  switch (action.type) {
    case PENDING_RA_START:
      return getPendingRaStart(state, action);
    case PENDING_RA_SUCCESS:
      return getPendingRaSuccess(state, action);
    case PENDING_RA_FAIL:
      return getPendingRaFail(state, action);

    default:
      return state;
  }
};

export default PendingRaReducer;
